<template>
  <BaseWorkPageLayout
    :title="$t('global.activities')"
    icon="file-alt"
    with-back-button
  >
    <ActivityTable :activities="invoiceActivity ?? []" />
  </BaseWorkPageLayout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'InvoicingTabActivity',
  computed: {
    ...mapGetters({ invoiceActivity: 'invoicing/getInvoiceActivity' })
  },
  methods: {
    ...mapActions({ fetch: 'invoicing/fetchInvoiceActivitiesByInvoiceID' })
  },
  beforeMount() {
    this.fetch({ invoice_id: this.$route.params.invoicing_id })
  }
}
</script>
